import React, { useState } from "react";
import axios from "axios";
import { Lock, ArrowRight } from "lucide-react";
import { API, formatApiError } from "./api";

export const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      onLogin(data.token);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full rounded-lg border border-[#ded5c4] bg-white px-4 py-3 text-[15px] text-[#26241F] outline-none transition-colors focus:border-[#B08D57]";

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#26241F] px-5">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm rounded-3xl bg-[#FBF9F5] p-8">
        <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#26241F] text-[#B08D57]"><Lock className="h-5 w-5" /></span>
        <h1 className="mt-5 font-serifDisplay text-[28px] text-[#26241F]"><span className="text-[#B08D57]">L</span>oyaris — Espace admin</h1>
        <p className="mt-1 text-[14px] text-[#6e6a62]">Connectez-vous pour consulter les demandes.</p>
        <div className="mt-6 space-y-4">
          <input data-testid="admin-email-input" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={field} />
          <input data-testid="admin-password-input" type="password" required placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} className={field} />
        </div>
        {error && <p data-testid="admin-login-error" className="mt-3 text-[13px] text-red-700">{error}</p>}
        <button data-testid="admin-login-submit" disabled={loading} className="group mt-6 flex w-full items-center justify-center gap-2 rounded-md bg-[#26241F] px-6 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-[#B08D57] hover:text-[#26241F] disabled:opacity-60">
          {loading ? "Connexion…" : "Se connecter"} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
        </button>
      </form>
    </div>
  );
};
